import React from 'react';

const loadingLogoImageUrl = `${process.env.REACT_APP_ASSETS_URL}/img-logo-oval-cat.svg`;

const GlobalLoadingOverlay = () => (
  <div className='fixed inset-0 z-50 flex items-center justify-center pointer-events-none bg-surface-lightgray80 border border-black w-full'>
    <div className='flex flex-col items-center px-6 tabletH:px-20'>
    {/* 구버전 이미지 임시 비활성화 */}
      {/* <div className='flex pb-4 items-start w-[140px] h-[110px] tabletH:w-[160px] tabletH:h-[133px]'>
        <img
          src={loadingLogoImageUrl}
          alt='Loading...'
          className='w-[140px] tabletH:w-[160px] h-auto'
        />
      </div> */}
      <div className='flex flex-col w-full tabletH:w-[570px] items-center gap-2 text-center pb-[120px]'>
        <p className='typo-title1 tabletH:typo-h7 text-text-primary'>
          One moment...
        </p>
        <p className='typo-b16Strong tabletH:typo-title3 text-text-primary'>
          Updating your results
        </p>
      </div>
    </div>
  </div>
);

export default GlobalLoadingOverlay;
